<template
  ><div ref="grid" class="scene-list" :class="{ collapsed: collapsed && !sorting }">
    <draggable
      v-model="items"
      :disabled="!sorting"
      :animation="200"
      :force-fallback="true"
      class="control-grid scene-grid"
      @change="syncOrder"
      ><scene-item-view
        v-for="scene in items"
        :key="scene.sceneId"
        :OneScene="scene"
        :viewType="viewType === 'configScene' ? 'configScene' : ''"
        @followOrderCompuder="removeFollow"
        @followOrderCompuInc="addFollow"
    /></draggable></div
></template>
<script>
import draggable from 'vuedraggable'
import SceneItemView from './scene-item-view'
import { changefollowOrder, changefollowOrderInc } from '@/common/tool'
export default {
  components: { draggable, SceneItemView },
  props: { sceneList: { type: Array, default: () => [] }, viewType: String },
  data() {
    return { items: this.sceneList }
  },
  computed: {
    sorting() {
      return this.$store.state.configinfo.objectMoveState
    },
    collapsed() {
      return this.viewType === 'home'
        ? this.$store.state.publicinfo.showHomeSenceText === '展开'
        : this.viewType === 'region' && this.$store.state.publicinfo.showRegionSenceText === '展开'
    }
  },
  watch: {
    sceneList(value) {
      this.items = value
      this.$nextTick(this.measure)
    },
    'sceneList.length'() {
      this.$nextTick(this.measure)
    }
  },
  methods: {
    measure() {
      const el = this.$refs.grid
      if (!el) return
      const grid = el.querySelector('.scene-grid')
      if (!grid) return
      const columns = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1
      const count = Math.max(0, this.items.length - columns * 2)
      if (this.viewType === 'home') this.$store.dispatch('asyUpdataHomeSenceCount', count)
      else if (this.viewType === 'region') this.$store.dispatch('asyUpdataRegionSenceCount', count)
    },
    syncOrder() {
      if (this.viewType === 'home')
        this.$store.dispatch('asyUpdatahomeServeDatasceneList', this.items)
      else if (this.viewType === 'region')
        this.$store.dispatch('asyUpdataregionServeDatasceneList', this.items)
    },
    removeFollow(value) {
      changefollowOrder(this.items, value)
    },
    addFollow(value) {
      changefollowOrderInc(this.items, value)
    }
  },
  mounted() {
    this.measure()
    window.addEventListener('resize', this.measure)
  },
  activated() {
    this.$nextTick(this.measure)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.measure)
  }
}
</script>
<style scoped>
.scene-list {
  margin-bottom: 14px;
}
.scene-list.collapsed {
  max-height: 138px;
  overflow: hidden;
}
@media (max-width: 480px) {
  .scene-list.collapsed {
    max-height: 138px;
  }
}
</style>
